"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardConfig = exports.StakeConfig = exports.PlatformBlockchain = void 0;
const utils_1 = require("../utils");
const chain_1 = require("./chain");
const constants_1 = require("./constants");
const vm_1 = require("./vm");
class PlatformBlockchain extends chain_1.AbstractBlockchain {
    stakeConfig;
    rewardConfig;
    rewardCalculator;
    constructor(name, id, asset, stakeConfig, rewardConfig, aliases, registeredAssets = []) {
        super(name, id, new vm_1.ChainVM(constants_1.PLATFORMVM_ID, vm_1.VMType.JVM, vm_1.VMWalletType.Utxo, constants_1.JVM_HD_PATH), asset, aliases, registeredAssets);
        this.stakeConfig = stakeConfig;
        this.rewardConfig = rewardConfig;
        this.rewardCalculator = new utils_1.RewardCalculator(rewardConfig);
    }
    async fetchAsset(provider, assetId) {
        return await (0, utils_1.fetchJNT)(provider, assetId);
    }
    validateAddress(address, hrp) {
        return (0, utils_1.validateBech32)(address, hrp, this.aliases.concat(this.id));
    }
    estimatePrimaryValidationReward(stakePeriod, stakeAmount) {
        return this.rewardCalculator.calculate(stakePeriod, utils_1.TimeUtils.now(), stakeAmount);
    }
    estimatePrimaryDelegationReward(stakePeriod, stakeAmount) {
        const rewards = this.rewardCalculator.calculate(stakePeriod, utils_1.TimeUtils.now(), stakeAmount);
        return (rewards * BigInt(constants_1.BaseShare - this.stakeConfig.minDelegationFee)) / BigInt(constants_1.BaseShare);
    }
}
exports.PlatformBlockchain = PlatformBlockchain;
class StakeConfig {
    uptimeRequirement;
    minValidatorStake;
    maxValidatorStake;
    minDelegatorStake;
    minDelegationFee;
    maxDelegationFee;
    minStakeDuration;
    maxStakeDuration;
    constructor(uptimeRequirement, minValidatorStake, maxValidatorStake, minDelegatorStake, minDelegationFee, maxDelegationFee, minStakeDuration, maxStakeDuration) {
        this.uptimeRequirement = uptimeRequirement;
        this.minValidatorStake = minValidatorStake;
        this.maxValidatorStake = maxValidatorStake;
        this.minDelegatorStake = minDelegatorStake;
        this.minDelegationFee = minDelegationFee;
        this.maxDelegationFee = maxDelegationFee;
        this.minStakeDuration = minStakeDuration;
        this.maxStakeDuration = maxStakeDuration;
    }
}
exports.StakeConfig = StakeConfig;
class RewardConfig {
    minStakePeriod;
    maxStakePeriod;
    stakePeriodRewardShare;
    startRewardTime;
    startRewardShare;
    diminishingRewardTime;
    diminishingRewardShare;
    targetRewardTime;
    targetRewardShare;
    constructor(minStakePeriod, maxStakePeriod, stakePeriodRewardShare, startRewardTime, startRewardShare, diminishingRewardTime, diminishingRewardShare, targetRewardTime, targetRewardShare) {
        this.minStakePeriod = minStakePeriod;
        this.maxStakePeriod = maxStakePeriod;
        this.stakePeriodRewardShare = stakePeriodRewardShare;
        this.startRewardTime = startRewardTime;
        this.startRewardShare = startRewardShare;
        this.diminishingRewardTime = diminishingRewardTime;
        this.diminishingRewardShare = diminishingRewardShare;
        this.targetRewardTime = targetRewardTime;
        this.targetRewardShare = targetRewardShare;
    }
}
exports.RewardConfig = RewardConfig;
